import ProjectCover from "./cover";
import ProjectDescription from "./description";
import ProjectName from "./name";
import ProjectTags from "./tags";
import ProjectTimestamp from "./timestamp";
import { useAppSelector } from "@/redux/store/hooks";
import type { Project } from "@/types";

const Card = ({ project }: { project: Project }): JSX.Element => {
  const { queryFilter } = useAppSelector((state) => state.projectFinder);

  const {
    showProjectImage,
    showProjectTimestamp,
    showProjectName,
    showProjectDescription,
    showProjectTags,
    componentSequence
  } = queryFilter;

  const sequence =
    typeof componentSequence === "string"
      ? componentSequence.split(",")
      : componentSequence;

  const cardComponents = {
    title: showProjectName ? (
      <ProjectName key="title" project={project} />
    ) : null,
    cover: showProjectImage ? (
      <ProjectCover key="cover" project={project} />
    ) : null,
    tags: showProjectTags ? <ProjectTags key="tags" project={project} /> : null,
    timestamp: showProjectTimestamp ? (
      <ProjectTimestamp key="timestamp" project={project} />
    ) : null,
    description: showProjectDescription ? (
      <ProjectDescription key="description" project={project} />
    ) : null
  };

  return <>{sequence.map((key) => cardComponents[key])}</>;
};

export default Card;
